import React from 'react';
import {
  Header,
  Image,
  Segment,
} from 'semantic-ui-react';

import {
  CustomContainer,
  FollowingBtn,
  FollowingBtnGuide,
  ShareBtn,
} from '../../common';
import {
  formatDatetime,
  getUserAvatar,
} from '../../Utils';

interface InfoProps {
  authed: boolean;
  data: {
    id: string;
    last_visit: string;
    nickname?: string;
  };
  isMobile: boolean;
}

export default ({
  authed,
  data: {
    id,
    // num_replies,
    // num_hates,
    // num_likes,
    // num_articles,
    last_visit: lastVisit,
    nickname,
  },
  isMobile,
}: InfoProps) => (
  <CustomContainer>
    <Segment>
      {
        authed ? (
          <FollowingBtn
            platform="ptt"
            type="user"
            id={id}
          />
        ) : (
          <FollowingBtnGuide />
        )
      }
      <ShareBtn />
      <Image
        circular
        centered
        size={isMobile ? 'tiny' : 'small'}
        src={getUserAvatar(id)}
      />
      <Header
        as={isMobile ? 'h3' : 'h2'}
        icon
        textAlign="center"
      >
        <Header.Content>
          {id}
          (
          {nickname || '沒有綽號喔'}
          )
          <Header.Subheader
            style={{ paddingTop: '4px' }}
          >
            上次留下足跡
            {formatDatetime(lastVisit)}
          </Header.Subheader>
        </Header.Content>
      </Header>
    </Segment>
  </CustomContainer>
);
